import Suswindow from './Suswindow';
Suswindow.install = function(Vue) {
  Vue.component(Suswindow.name, Suswindow);
};

export default Suswindow;
